import { nearestFeatureLineStringsFromLayer } from "./parkingGIS";

function getZoneFromId(zones, id) {
  var val = "null";
  zones.forEach((row) => {
    if (row.code === id) {
      val = row;
    }
  });
  return val;
}

function matMatching(layer, coord, callback) {
  var feature = nearestFeatureLineStringsFromLayer(coord, layer);
  if (feature !== null && feature !== undefined) {
    /* var featureProp = feature.getProperties();
    if (featureProp !== null) {
      if (typeof callback === "function") {
        callback(featureProp);
      }
    } else {
      callback(null);
    }*/
    callback(feature);
  } else {
    callback(null);
  }
}

export { getZoneFromId, matMatching };
